import { render } from "./CreateSellerPage.vue?vue&type=template&id=4bea5910&ts=true"
import script from "./CreateSellerPage.vue?vue&type=script&lang=ts"
export * from "./CreateSellerPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__